import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { U_BUTTON__user_task_create } from './buttons/U_BUTTON__user_task_create';
import { U_BUTTON__user_tasks_hide_unused } from './buttons/U_BUTTON__user_tasks_hide_unused';
import { U_LIST__user_tasks } from './list/U_LIST__user_tasks';

export function U_SIDEBAR__user_tasks_list() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_USER_TASKS);

  return (
    <div className="w-full flex flex-col h-full  bg-component">
      <div className="w-full flex items-center justify-evenly h-6 bg-bar">
        <U_BUTTON__user_task_create />
        <U_BUTTON__user_tasks_hide_unused />
      </div>
      <U_LIST__user_tasks />
    </div>
  );
}
